import { Component, OnInit, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'itpx-catalog-template-host',
  templateUrl: './catalog-template-host.component.html',
  styleUrls: ['./catalog-template-host.component.css']
})
export class CatalogTemplateHostComponent implements OnInit {

  @Input() templateKey: string;
  @Input() templates: { [key: string]: TemplateRef<any> };

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/catalog-modal/catalog-template-host.component.ts